/**
 * The regulation response
 */
export class RegulationResponse {
    /**
     * The exists
     */
    exists: boolean;
    /**
     * The ambito code
     */
    ambitoCode: string;

    /**
     * The constructor
     * @param exists The exists value
     * @param ambitoCode The ambitoCode 
     */
    constructor(exists: boolean, ambitoCode: string) {
        this.exists = exists;
        this.ambitoCode = ambitoCode;
    }
}